import { render } from "./LoginAdmin.vue?vue&type=template&id=493e0edf&scoped=true"
import script from "./LoginAdmin.vue?vue&type=script&lang=js"
export * from "./LoginAdmin.vue?vue&type=script&lang=js"

import "./LoginAdmin.vue?vue&type=style&index=0&id=493e0edf&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-493e0edf"]])

export default __exports__